/* eslint-disable @typescript-eslint/no-explicit-any */
import { useMutation } from '@tanstack/react-query';
import { apiClient } from '@lib/api-client';
import { notifications } from '@mantine/notifications';
import { useTranslation } from 'react-i18next';
import useStore from '@store/index';
import { queryClient } from '@lib/react-query';

export const createOffset = (
	data: any
): Promise<{
	response: any;
}> => {
	return apiClient.post('/offsets', data);
};

export const useCreateOffset = () => {
	const { t } = useTranslation();
	const {
		setOffsetOpenDrawer,
		setOffsetCreationActiveStep,
		setOffsetAdditionalProjects,
		setOffsetAdditionalProjectsSelected,
		setOffsetMesurabilityProjects,
		setOffsetMesurabilityProjectsSelected,
		setOffsetProjectMixinAco2,
		setOffsetProjectMixinAddi,
		setOffsetStep2Error,
		setOffsetStep3Error,
		setOffsetCreationDatas,
		setOffsetMesurabilityProjectsPage,
		setOffsetAdditionalProjectsPage,
	} = useStore();
	const {
		mutate,
		isPending: isLoading,
		status,
		data: response,
	} = useMutation({
		mutationFn: createOffset,
		onSuccess: () => {
			setOffsetCreationActiveStep(0);
			setOffsetOpenDrawer(false);
			setOffsetAdditionalProjects([]);
			setOffsetAdditionalProjectsSelected([]);
			setOffsetMesurabilityProjects([]);
			setOffsetMesurabilityProjectsSelected([]);
			setOffsetProjectMixinAco2([]);
			setOffsetProjectMixinAddi([]);
			setOffsetStep2Error(false);
			setOffsetStep3Error(false);
			setOffsetCreationDatas({});
			setOffsetMesurabilityProjectsPage(1);
			setOffsetAdditionalProjectsPage(1);
			notifications.show({
				title: t('global.success'),
				message: t(
					'offsets.notifications.offsetSuccessfullyAdded'
				),
				color: 'success',
			});
			queryClient.invalidateQueries({
				queryKey: ['offsets'],
			});
		},
		onError: (error: any) => {
			notifications.show({
				title: t('global.error'),
				message: t(`api.${error.type}`),
				color: 'error',
			});
		},
	});

	return { mutate, isLoading, status, response };
};
